export interface ResetConfirmationDialog {
  returnValue: string;
  showModal(): void;
}

export const openResetConfirmation = (dialog: ResetConfirmationDialog): void => {
  dialog.returnValue = 'cancel';
  dialog.showModal();
};
